import React from 'react';
import CountrySelect from "./custom_country_select";
import en from 'react-phone-number-input/locale/en.json';
import PhoneInput, { Country } from 'react-phone-number-input/input';
import {parsePhoneNumberFromString, getCountryCallingCode, type CountryCode, parsePhoneNumber} from "libphonenumber-js";
import styles from '../../styles/phone_input/custom_phone_input.module.scss';

interface CustomPhoneInputProps {
  value: string;
  onChange: (value: string) => void;
}

export default function CustomPhoneInput({ value, onChange }: CustomPhoneInputProps) {
  const [country, setCountry] = React.useState<CountryCode | undefined>('SG');

  React.useEffect(() => {
    if (!value) return;

    try {
      const phoneNumber = parsePhoneNumberFromString(value);
      if (phoneNumber?.country && phoneNumber.country !== country) {
        setCountry(phoneNumber.country as CountryCode);
      }
    } catch (error) {
      console.error('Phone parsing error:', error);
    }
  }, [value, country]);

  const phoneInputChangeHandler = React.useCallback(
    (newValue?: string) => {
      onChange(newValue || '');
    },
    [onChange]
  );

  const countryChangeHandler = React.useCallback(
    (newCountry?: string) => {
      if (!newCountry) {
        setCountry(undefined);
        return;
      }

      setCountry(newCountry as CountryCode); // Ensure type safety

      try {
        const phoneNumber = parsePhoneNumber(value);
        const nationalNumber = phoneNumber.nationalNumber;
        const formatted = `+${getCountryCallingCode(newCountry as CountryCode)}${nationalNumber}`;
        onChange(formatted);
      } catch (error) {
        onChange(`+${getCountryCallingCode(newCountry as CountryCode)}`);
      }
    },
    [value, onChange]
  );

  return (
    <div className={styles.field}>
      <CountrySelect
        labels={en}
        value={country}
        onChange={countryChangeHandler}
        className={styles.countrySelect}
      />

      <PhoneInput
        className={`${styles.phoneInput} form-control`}
        defaultCountry={country as Country}
        value={value}
        onChange={phoneInputChangeHandler}
        placeholder="Enter phone number"
      />
    </div>
  );
}
